<template>
    <div>
        <v-layout row pa-0 ma-0 >
            <v-flex v-for="index in 10" pa-0 ma-0 :class="{ selected: (currentFrame == index - 1) }" class="frame-box" @click="FrameClicked(index)">
                <!-- <p>1 {{frames[index-1].first}}</p>
                <p>2 {{frames[index-1].second}}</p>
                <p>3 {{frames[index-1].third}}</p> -->
                <h3>{{displayCountPerFrame(index)}}</h3>                
                <p >{{getScoreForFrame(index-1)}}</p>
                <rack-graphic :frameno="index-1" :frame="frames[index-1]" ref="frame-graphics" />
            </v-flex>
        </v-layout>
        <v-layout row>            
            <v-flex md2>
                <h2>{{currentFrameAndThrow}}</h2>
            </v-flex >
            <v-flex md2>
                <p>Ten-pins: {{tenPins}}</p>
            </v-flex >
            <v-flex md1>
                <v-container > 
                    <v-layout row align-center>
                        <input  large :disabled="pinIsDisabled(index+5)" type="checkbox"  
                        @change=somePinChecked v-for="index in 4" :key="index"  v-model=pins[index+5].val />
                    </v-layout>
                    <v-layout row align-center>
                        <input :disabled="pinIsDisabled(index+2)" type="checkbox" 
                        @change=somePinChecked v-for="index in 3" :key="index" name="check" color="success" v-model=pins[index+2].val />
                    </v-layout>
                    <v-layout row align-center>
                        <input :disabled="pinIsDisabled(index)" type="checkbox" 
                        @change=somePinChecked v-for="index in 2" :key="index" name="check" color="success" v-model=pins[index].val />
                    </v-layout>
                    <v-layout row align-center>
                        <input :disabled="pinIsDisabled(index -1)" type="checkbox" 
                        @change=somePinChecked v-for="index in 1" :key="index" name="check" color="success" v-model=pins[index-1].val />
                    </v-layout>
                </v-container>
            </v-flex>
            <v-flex md1>
                <v-container
                    class="px-0"
                    fluid
                    >
                    <v-switch
                        v-model="assumeStrike"
                        :label='assumeStrike ? "Assuming Strike" : "Check each pins"'
                        @change="onAssumingStrikeChange($event)"
                    ></v-switch>
                </v-container>
            </v-flex>
        </v-layout>
        <v-layout row>
            <div id="app">
                <canvas  id="myCanvas" ref="myCanvas" width="250" height="250" @touchmove="touchDraw" @mousemove="mouseDraw" @mousedown="beginDrawing" @mouseup="stopDrawing" @touchend="stopTouch" @touchstart=beginTouch />
            </div>
        </v-layout>
        <v-layout row wrap>
            <v-btn @click="strike">X</v-btn>
            <v-btn @click="spare">/</v-btn>
            <v-btn @click="OnNext">Next</v-btn>            
            <v-btn @click="clearGame">Clear Game</v-btn>            
            <v-btn @click="clearPins">Clear Pins</v-btn>                        
            <v-btn @click="drawRect">Redraw Graphcis</v-btn>
        </v-layout>
    </div>
</template>

<script>
    import axios from "axios";
    import RackGraphic from './RackGraphic';
    export default {
        components: {
            RackGraphic
        },       
        props: ['frame_no', 'canvas_width'], 
        name: "frame-editor",
        data () {
            return {
                canvas: null,
                x: 0,
                y: 0,
                isDrawing: false,
                assumeStrike: false,
                lastMask: 0,
                currentFrame: 0,
                currentThrow: 0,
                pins : [ 
                    {val: false, mask: 1},
                    {val: false, mask: 2}, 
                    {val: false, mask: 4}, 
                    {val: false, mask: 8}, 
                    {val: false, mask: 16}, 
                    {val: false, mask: 32}, 
                    {val: false, mask: 64}, 
                    {val: false, mask: 128}, 
                    {val: false, mask: 256}, 
                    {val: false, mask: 512}   
                    ],
                frames: [
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                    { first: null, second: null, third: null },
                ],
                exampleContent: "This is TEXT",
                score: 0,
                url: "https://nostyleguy.com/api/frame",
                pinGraphics: [
                    { x: 125, y: 187.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},

                    { x: 100, y: 137.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 150, y: 137.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},

                    { x: 75, y: 87.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 125, y: 87.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 175, y: 87.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},

                    { x: 50, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 100, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 150, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                    { x: 200, y: 37.5, r: 25, changedThisSwipe: false, disabled: false, fill: false},
                ],
            }
        },
        computed: {            
            currentFrameAndThrow(){
                return "Frame" + (this.currentFrame + 1) + " Throw" + (this.currentThrow +1); 
            },
            computeFrameScore(i){

            },
            scoreMask(){
                return getScoreMask();
            },
            tenPins(){
                let total = 0;
                let made = 0;
                for(var i in this.frames){
                    if(this.frames[i].first == 511){
                        total += 1
                    }
                    if(this.frames[i].second == 512){
                        made += 1;
                    }
                }
                return `${made}/${total}`;
            }
        },
        methods: {
            drawLine(x1, y1, x2, y2) {
                let ctx = this.canvas;
                ctx.beginPath();
                ctx.strokeStyle = 'black';
                ctx.lineWidth = 1;
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
                ctx.closePath();
            },
            touchDraw(e){                
                if(!this.isDrawing) {
                    return
                }
                let xy = this.getXY(e);
                this.commonDraw(xy.x, xy.y);
            },
            mouseDraw(e){                
                if(!this.isDrawing) {
                    return
                }
                this.commonDraw(e.offsetX, e.offsetY);
            },
            getXY(e){
                var source = e.touches ? e.touches[0] : e;
                const {
                    clientX,
                    clientY
                } = source;
                const {
                    left,
                    top
                } = this.$refs["myCanvas"].getBoundingClientRect();

                const x = clientX - left;
                const y = clientY - top;

                return {
                    x,
                    y
                };
            },
            commonDraw(x, y) {
                if(this.isDrawing) {
                    this.x = x;
                    this.y = y;
                    this.determineIfTouchIsPinChange(this.x, this.y);
                }
            },
            beginDrawing(e) {
                console.log("beginDrawing");
                this.x = e.offsetX;
                this.y = e.offsetY;
                this.determineIfTouchIsPinChange(this.x, this.y);
                this.isDrawing = true;
            },
            beginTouch(e) {
                console.log("beginTouch");
                this.x = e.touches[0].clientX;
                this.y = e.touches[0].clientY;
                this.determineIfTouchIsPinChange(this.x, this.y);
                this.isDrawing = true;
            },
            stopDrawing(e) {
                console.log("stopDrawing");
                if (this.isDrawing) {
                    //this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
                    this.x = 0;
                    this.y = 0;
                    this.isDrawing = false;
                }
                for(var i in this.pinGraphics){
                    this.pinGraphics[i].changedThisSwipe = false;
                }
            },
            stopTouch(e) {
                console.log("stopTouch");
                if (this.isDrawing) {
                    this.x = 0;
                    this.y = 0;
                    this.isDrawing = false;
                }
                for(var i in this.pinGraphics){
                    this.pinGraphics[i].changedThisSwipe = false;
                }
            },
            determineIfTouchIsPinChange(x, y){
                for(var i in this.pinGraphics){
                        let pin = this.pinGraphics[i];
                        let dy = pin.x - x;
                        let dx = pin.y - y;
    
                        let distance =  Math.sqrt(dx * dx + dy * dy);
                        if(distance < 25 && !this.pinIsDisabled(i) ){
                            if(!this.pinGraphics[i].changedThisSwipe){
                                this.pinGraphics[i].changedThisSwipe = true;
                                this.pins[i].val = !this.pins[i].val;
                                this.drawRect();
                                this.somePinChecked();
                            }
                        }
                        else {
                            this.pinGraphics[i].changedThisSwipe = false;
                        }
                    }
            },
            onAssumingStrikeChange(value){
                this.clearPins();
                this.drawRect();
            },
            syncPins(){
                let throwMask = 0;
                switch(this.currentThrow){
                    case 0:
                        throwMask = this.frames[this.currentFrame].first;
                        break;
                    case 1:
                        throwMask = this.frames[this.currentFrame].second;
                        break;
                    case 2:
                        throwMask = this.frames[this.currentFrame].third;
                        break;
                    default:
                        throwMask = this.frames[this.currentFrame].first;
                        break;
                }
                for(var i in this.pins){
                    let value =  ((throwMask & this.pins[i].mask) == this.pins[i].mask);
                    // This is sneakily important. If we have any value for the current
                    // throw, don't actually use this.assumeStrike to fill the pins,
                    // otherwise we will overwrite good data. 
                    this.pins[i].val = (throwMask != null) ? value : this.assumeStrike
                }                
                this.drawRect();
            },
            FrameClicked(i){
                this.currentFrame = i - 1;
                this.currentThrow = 0; 
                this.syncPins();                
            },
            FinishFrameLabel(){
                if(this.currentFrame == 9){
                    if(this.currentThrow == 0 || this.currentFrame == 2){
                        return "X"
                    }
                    else if(this.currentThrow == 1){
                        return this.isStrike(9) ? "X" : "/"
                    }
                    else {
                        return "-"
                    }
                }
                else {
                    return this.currentThrow == 1 ? "/" : "X";
                }
            },
            somePinChecked(){
                var str = "";
                for(var i in this.pins){
                    str += this.pins[i].val;
                }
                this.setScore();
                this.drawRect();
            },
            pinIsDisabled(i){
                var mask = Math.pow(2,i);
                if(this.currentFrame != 9 && this.currentThrow != 0){
                    var disabled = ((this.frames[this.currentFrame].first & mask) == mask) ? true: false;
                    return disabled;
                }
                else { // 10th frame. Special logic
                    if (this.currentThrow == 1){ // 2nd throw
                        if( !this.isStrike(9)){
                            return ((this.frames[this.currentFrame].first & mask) == mask) ? true: false;
                        }
                    }
                    else { // 1st or 3rd throw are always enabled 
                        return false;
                    }
                }
            },
            displayCountPerFrame(i){
                var firstCount = this.bitCount(this.frames[i-1].first);
                var secondCount = this.bitCount(this.frames[i-1].second);                    
                var thirdCount = this.bitCount(this.frames[i-1].third);
                if(i == 10) {
                    var firstStr="";
                    var secondStr="";
                    var thirdStr=""
                    firstStr += firstCount == 10 ? "X" : firstCount;
                    secondStr += secondCount== 10 ? "X" : secondCount;
                    thirdStr += thirdCount== 10 ? "X" : (thirdCount > 0 ? thirdCount : "");
                    if(firstCount + secondCount == 10 && firstCount != 10){
                        secondStr = "/";
                    }
                    return firstStr+" "+secondStr+" "+thirdStr; 
                }
                else {
                    if(firstCount == 10) {
                        return "X";
                    }
                    else if ( (firstCount + secondCount) == 10){
                        return firstCount + "/"
                    }
                    else{
                        return firstCount + " " + secondCount;
                    } 
                }
            },
            bitCount (n) {
                n = n - ((n >> 1) & 0x55555555)
                n = (n & 0x33333333) + ((n >> 2) & 0x33333333)
                return ((n + (n >> 4) & 0xF0F0F0F) * 0x1010101) >> 24
            },
            getScoreMask(){
                var ret = 0;
                this.pins.forEach(p => {
                    if(p.val ){
                        ret += p.mask;
                    }
                })
                return ret;
            },
            isStrike(i){
                if(i < 0 || i > 9) { 
                    return false;
                }
                return this.bitCount(this.frames[i].first) == 10;
            },
            isSpare(i){
                if(i < 0 || i > 9) { 
                    return false;
                }
                return (this.bitCount(this.frames[i].first) + this.bitCount(this.frames[i].second) == 10 && !this.isStrike(i));
            },
            getFirstCount(i){
                if(i < 0 || i > 9) { 
                    return 0;
                }
                return this.bitCount(this.frames[i].first);
            },
            getSecondCount(i){
                if(i < 0 || i > 9) { 
                    return 0;
                }
                return this.bitCount(this.frames[i].second);
            },
            getSpareFillforFrame(i){
                //10th frame. Use 10th frame 3rd
                if(i == 9){
                    return this.bitCount(this.frames[i].third);
                }
                // Otherwise, use next frame first
                else {
                    return this.bitCount(this.frames[i+1].first);
                }
            },
            getStrikeFillforFrame(i){
                // 10th frame strike. Return 10th 2nd and 3rd no matter what
                if(i == 9){
                    return this.bitCount(this.frames[i].second) + this.bitCount(this.frames[i].third);
                }
                // 9th frame strike. Return 10th 1st and 2nd no matter what
                else if(i == 8){ 
                    return this.bitCount(this.frames[9].first) + this.bitCount(this.frames[9].second);
                }
                // 1st through 8th frame strike. Conditional based on next frame first being a strike or not
                else {
                    if(this.isStrike(i+1)){
                        return 10 + this.bitCount(this.frames[i+2].first);
                    }
                    else {
                        return this.bitCount(this.frames[i+1].first) + this.bitCount(this.frames[i+1].second);
                    }
                }
            },
            getScoreForFrame(i){
                if(i < 0){
                    return 0;
                }
                
                if(this.isStrike(i) ){
                    return this.getScoreForFrame(i-1) + 10 + this.getStrikeFillforFrame(i);
                }
                else if (this.isSpare(i)){
                    return this.getScoreForFrame(i-1) + 10 + this.getSpareFillforFrame(i);
                }
                else {
                    return this.getScoreForFrame(i - 1) + this.bitCount(this.frames[i].first) + this.bitCount(this.frames[i].second);
                }
            },
            OnNext(){
                if(this.currentFrame == 9){
                    if(this.currentThrow == 0){
                        this.setScore();
                        this.currentThrow++;                       

                        // Struck in 10th 1st. Reset pins
                        if(this.isStrike(this.currentFrame)){
                            this.clearPins();
                        }
                    } 
                    else if(this.currentThrow == 1){
                        this.setScore();

                        // Struck in 10th 2nd. Reset pins
                        if(this.bitCount(this.frames[9].second) == 10 || this.isSpare(9)){
                            this.clearPins();
                        }

                        // As long as we spared or struck in the 1st throw of the 10th, we get a 3rd shot
                        if(this.isStrike(9) || this.isSpare(9)){
                            this.currentThrow++;
                        }
                        // Otherwise, start over
                        else {
                            this.currentFrame = 0;
                            this.currentThrow = 0;
                            this.clearPins();
                        }
                    }
                    else if(this.currentThrow == 2){
                        this.setScore();
                        this.currentFrame = 0;
                        this.currentThrow = 0;
                        this.clearPins();
                    }
                }
                else {       
                    this.setScore();
                    if(this.currentThrow == 1){  
                        this.currentFrame += 1;
                        this.currentThrow = 0;
                        this.clearPins();
                    } 
                    else {
                        if(this.isStrike(this.currentFrame)){
                            this.currentFrame+= 1;
                            this.currentThrow = 0;
                            this.clearPins();
                        }
                        else {
                            this.currentThrow = 1;
                        }
                    }
                }
                this.syncPins();
            },
            clearGame(){                
                for(var i in this.pins){
                    this.pins[i].val = this.assumeStrike;
                }                
                for(var i in this.frames){
                    this.frames[i].first = null;
                    this.frames[i].second = null;
                    this.frames[i].third = null;
                }
                this.currentFrame = 0;
                this.currentThrow = 0;
            },
            strike() {
                for(var i in this.pins){
                    this.pins[i].val = true;
                }
                this.setScore();
                this.OnNext();
            },
            spare() {
                if(this.currentThrow == 0){
                    this.setScore();
                    this.OnNext();
                }
                for(var i in this.pins){
                    this.pins[i].val = true;
                }
                this.setScore();
                this.OnNext();
            },
            submit: async function(){
                let payload = {
                    first_name: this.firstName,
                    last_name: this.lastName
                };
                axios({
                    method: "POST",
                    url: this.url,
                    data: payload,
                    headers: {
                        "content-type": "application/json"
                    }
                }).
                then(
                    result => {
                        console.log(JSON.stringify(result.data));
                        this.$store.dispatch('getBowlers');
                    },
                    error => {
                        console.error(error);
                    }
                );
            },
            setScore(){          
                var mask = this.getScoreMask();
                if(this.currentThrow == 0){
                    this.frames[this.currentFrame].first = mask;
                }
                else if(this.currentThrow == 1){
                    if(this.currentFrame == 9 && this.isStrike(9) ) {                       
                        this.frames[this.currentFrame].second = mask;
                    }
                    else {           
                        this.frames[this.currentFrame].second = (mask & ~this.frames[this.currentFrame].first);
                        console.log(`Set second throw to: ${this.frames[this.currentFrame].second}`)
                    }
                }
                else if(this.currentThrow == 2){
                    this.frames[this.currentFrame].third = mask;
                }
                this.$emit("updated", 
                    {
                        frame: this.currentFrame, 
                        first: this.frames[this.currentFrame].first,
                        second:this.frames[this.currentFrame].second,
                        third: this.frames[this.currentFrame].third
                    }
                );
            },
            clearPins(){
                console.log("Setting pins to: " + this.assumeStrike);
                for(var i in this.pins){
                    this.pins[i].val = this.assumeStrike;
                }
                this.syncPins();
            },
            LoadFrameData(frame){
                let index = frame.frame - 1
                this.frames[index].first = frame.first;
                this.frames[index].second = frame.second;
                this.frames[index].third = frame.third;
                this.syncPins();
            },
            drawRect() {
                this.canvas.clearRect(0, 0, 250, 250);                
                
                for(var i in this.pinGraphics){
                    let p = this.pinGraphics[i];
                    this.canvas.beginPath();
                    this.canvas.arc(p.x, p.y, p.r, 0, 2 * Math.PI);                    
                    
                    if( this.pinIsDisabled(i)){
                        this.canvas.fillStyle = '#555555';
                        this.canvas.fill();
                    }
                    else if(this.pins[i].val){
                        this.canvas.fillStyle = '#3eae56';
                        this.canvas.fill();
                    }
                    else{
                        this.canvas.fillStyle = null;
                    }
                    this.canvas.lineWidth = 5;
                    this.canvas.strokeStyle = '#003300';
                    this.canvas.stroke();
                } 
                for(var i in this.$refs['frame-graphics']){
                    this.$refs['frame-graphics'][i].drawRect();
                    console.log(`Calling draw on frame-graphic ${i}`)
                }

            },
        },
        mounted() {
            this.canvas = this.$refs["myCanvas"].getContext('2d');
            this.drawRect();
        },
        directives: {
            frameNumber: function(canvasElement, binding) {
                var ctx = canvasElement.getContext("2d");
                console.log("Width: " + ctx.parentNode.getBoundingClientRect());
                // var w= window.innerWidth-20) / 10;
                // canvasElement.width = w
                // Clear the canvas
                ctx.font = "20pt";
                ctx.fillText(binding.value, 15, 15);
                // ctx.rect(0,0,w-1, 80); 
                // ctx.stroke();
            }
        }
    }
</script>

<style  scoped>
#myCanvas {
  border: 1px solid grey;
  touch-action: none;
}

.frame-box {
  border:  1px solid black;
}

.selected {
    background-color: rgb(199, 199, 199);
}
</style>